export const GET_ALL_WEBSITES_REQUEST = 'GET_ALL_WEBSITES_REQUEST';
export const GET_ALL_WEBSITES_SUCCESS = 'GET_ALL_WEBSITES_SUCESSS';
export const GET_ALL_WEBSITES_FAIL = 'GET_ALL_WEBSITES_FAIL';
export const GET_ALL_WEBSITES_RESET = 'GET_ALL_WEBSITES_RESET';
